import adminApi from '../../components/apis/adminApi';

export function getCoreTickets(page) {
  return adminApi.post('/api/admin/tickets/core', {
    pagination: {
      pageIndex: page || 0,
    },
  }).then((res) => res.data);
}

export function getAdminTickets(page, values) {
  return adminApi.post('/api/admin/tickets', values, {
    params: {
      page: page || 1,
    },
  }).then((res) => res.data);
}
